import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormEditRole } from "./FormEditRole";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";

export const PanelEditRole = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [data, setData] = useState({
        name: "",
        permissions: [],
    });

    const getData = async () => {
        try {
            const { result, response } = await Helper.Get({
                url: `${api_Routes.Roles.GetOne}${id}`,
            });

            if (response) {
                // Extract permission IDs from the response
                const permissionIds = response.data.permissions.map(permission =>
                    permission.id.toString()
                );

                setData({
                    name: response.data.name || "",
                    permissions: permissionIds, // Set as array of IDs, not objects
                });
            }
        } catch (error) {
            console.error("Error fetching details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getPermissions = async () => {
        try {
            const { result, response } = await Helper.Get({
                url: `${api_Routes.Permissions.View}`,
            });
            if (response) {
                setPermissions(response.data);
            }
        } catch (error) {
            console.error("Error fetching details:", error);
        }
    };

    useEffect(() => {
        getData();
        getPermissions();
    }, []);

    return (
        <div>
            <PanelHead
                title={
                    isLoading ? (
                        <div className="flex items-center gap-4">
                            Edit Role <CircularProgress size={24} />
                        </div>
                    ) : (
                        <div className="flex items-center justify-between w-full gap-4">
                            <div>Edit Role: {data?.name}</div>
                        </div>
                    )
                }
            />
            <PanelBody
                content={
                    isLoading ? (
                        <LinearProgress />
                    ) : (
                        <FormEditRole
                            data={data}
                            permissions={permissions}
                            setData={setData}
                        />
                    )
                }
            />
        </div>
    );
};